<template>
  <b-modal
    ref="routeChangeAlertModal"
    v-model="showModal"
    :close-title="resource['label.Close']"
    size="md"
    :centered="true"
    :title="resource['label.Warning']"
    title-tag="h2"
    @hidden="$emit('stayPage')"
  >
    <div class="row">
      <div class="col">
        <!-- <div> -->
        <span>{{ resource['hrvenue.Create.RouteChangeInfo'] }}</span>
        <!-- </div> -->
      </div>
    </div>
    <div slot="modal-footer">
      <button
      id="stayPageBtn"
      name="stayPageBtn"
      class="btn md bg-white  text-color-purple"
        @click="$emit('stayPage')"
      >
      {{ resource['jobCreate.Exit.No'] }}
      </button>
      <button id="leavePageBtn"  class="btn md bg-purple text-white" @click="$emit('leavePage')">
        {{ resource['jobCreate.Exit.Yes'] }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'InterviewRouteChangeModal',

  props: {
    showRouteChangeModal: {
      type: Boolean,
      default: false,
    },
  },
  created() {},

  data() {
    return {
      showModal: false,
    };
  },

  watch: {
    showRouteChangeModal(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.showModal = newVal;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
